function initEventHandlers() {
    accodionIconToggle();
}

function accodionIconToggle() {
    $('.collapse.show').each(function() {
        $(this).prev('.isa-accordion__header').find('.isa-accordion__chevron').addClass('isa-accordion__chevron-up').removeClass('isa-accordion__chevron-down');
    });

    // Toggle up and down chevron icon on show hide of collapse element
    $('.collapse').on('show.bs.collapse', function() {
        $(this).prev('.isa-accordion__header').find('.isa-accordion__chevron').removeClass('isa-accordion__chevron-down').addClass('isa-accordion__chevron-up');
    }).on('hide.bs.collapse', function() {
        $(this).prev('.isa-accordion__header').find('.isa-accordion__chevron').removeClass('isa-accordion__chevron-up').addClass('isa-accordion__chevron-down');
    });
}

$(function () {
    initEventHandlers();
});
